<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-form-item label="零售仓库：" prop="storageId">
        <storages v-model="dataForm.storageId"></storages>
      </el-form-item>
      <el-form-item label="选择文件：">
        <el-button
          size="mini"
          icon="el-icon-upload"
          @click="showCommonDialog()"
          type="warning"
          >文件上传</el-button
        >
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">取消</el-button>
    </template>
    <common-upload
      ref="commonUpload"
      @success="uploadSuccessHandler"
      uploadUrl="/trade/sell/import"
      templateUrl="/static/template/零售数据导入模板.xlsx"
      title="零售数据导入"
      :data="dataForm"
    ></common-upload>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {},
    };
  },
  computed: {
    dataRule() {
      return {
        storageId: [
          {
            required: true,
            message: '请输入选择零售仓库',
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    uploadSuccessHandler(e) {
      this.$message.success('导入成功')
      this.cancel()
    },
    showCommonDialog() {
        this.$refs["dataForm"].validate((valid) => {
            if(!valid){
                return
            }
            this.$refs.commonUpload.init();
        })

    },
    reset() {
      this.dataForm = {
        agreementCode: "",
        storageId: "",
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
      });
    },
    cancel() {
      this.visible = false;
    },
  },
};
</script>
